import type React from 'react';

import { useCurrentProject } from '../../hooks/use-current-project';
import { buildBuilderEditorUrl, launchBuilderWindow } from '../../lib/builder-launch';

interface BuilderLaunchLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  projectId?: string;
  siteId?: string;
}

export function BuilderLaunchLink({
  projectId,
  siteId,
  onClick,
  rel,
  target,
  children,
  ...props
}: BuilderLaunchLinkProps): React.ReactElement {
  const { projectId: currentProjectId } = useCurrentProject();
  const resolvedProjectId = projectId ?? currentProjectId;
  const href = buildBuilderEditorUrl({
    ...(resolvedProjectId ? { projectId: resolvedProjectId } : {}),
    ...(siteId ? { siteId } : {}),
  });

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    onClick?.(event);

    if (event.defaultPrevented) {
      return;
    }

    const openedWindow = launchBuilderWindow({
      ...(resolvedProjectId ? { projectId: resolvedProjectId } : {}),
      ...(siteId ? { siteId } : {}),
    });
    if (openedWindow) {
      event.preventDefault();
    }
  };

  return (
    <a
      {...props}
      href={href}
      onClick={handleClick}
      rel={rel ?? 'noreferrer'}
      target={target ?? '_blank'}
    >
      {children}
    </a>
  );
}
